import React from 'react';

import { accountsSelectors } from 'app-components/flux/accounts';
import type { institutionLoginsTypes } from 'app-components/flux/institution-logins';
import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';

import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

import showManageUpdatesDialog from 'components/Dialogs/ManageUpdatesDialog/dispatcher';
import { isAppleCardAccount, isAppleCashAccount } from 'data/appleWallet/utils';
import { useAppSelector } from 'hooks/redux';

export const refreshFrequencyLabels: Partial<Record<institutionLoginsTypes.RefreshFrequency, string>> = {
  NONE: 'Always',
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  NEVER: 'Never',
};

type AccountManageUpdatesChipProps = ChipProps & { open?: boolean } & (
    | { accountId: string; institutionLoginId?: string }
    | { accountId?: string; institutionLoginId: string }
  );
const AccountManageUpdatesChip = ({
  accountId,
  institutionLoginId,
  open,
  ...otherProps
}: AccountManageUpdatesChipProps) => {
  const account = useAppSelector((state) => accountsSelectors.getAccountById(state, accountId));
  const institutionLogin = useAppSelector((state) =>
    institutionLoginsSelectors.getInstitutionLoginForId(state, institutionLoginId || account?.institutionLoginId || ''),
  );
  const updateIntervalLabel =
    (institutionLogin?.refreshFrequency && refreshFrequencyLabels[institutionLogin?.refreshFrequency]) || 'Unknown';

  const isAppleCash = isAppleCashAccount(account);
  const isAppleCard = isAppleCardAccount(account);

  const showAccountManageUpdatesChip = !isAppleCash && !isAppleCard;

  return (
    <>
      {showAccountManageUpdatesChip && (
        <Zoom
          in={Boolean(institutionLogin?.isConnected && (open || institutionLogin?.refreshFrequency !== 'NONE'))}
          unmountOnExit
        >
          <Chip
            sharedcomponentid='AccountManageUpdatesChip'
            label={updateIntervalLabel}
            size='small'
            variant='tonal'
            color='info'
            clickable
            icon={<ManageHistoryIcon />}
            onClick={() => {
              if (institutionLogin?.id) {
                showManageUpdatesDialog({ defaultValue: institutionLogin.id });
              }
            }}
            {...otherProps}
          />
        </Zoom>
      )}
    </>
  );
};

export default AccountManageUpdatesChip;
